module.exports = __webpack_public_path__ + "img/history.5ba13427.svg";